export default "__VITE_ASSET__3cJ8ffrrqqP95EATnvlgHw__";